import { computed, Injectable, signal } from "@angular/core";
import { AbstractControl } from "@angular/forms";
import { Color, ScaleType } from "@swimlane/ngx-charts";
import { Subject } from "rxjs";
import { StatusUpdateType } from "../modules/inner/tracking/loan-detail/history-activity/new-note-modal/new-note.modal";

export { AuthService } from "./auth.service";

// TODO: These probably belong in shared or themes
export const COLOR_SCHEME: Color = {
    name: "default",
    selectable: true,
    group: ScaleType.Ordinal,
    domain: [
        "#D39B1C",
        "#949D6A",
        "#BFB48F",
        "#273043",
        "#AF1725",
        "#9CAFB7",
        "#CC5803",
        "#034732",
        "#A57548",
        "#5E4955"
    ]
};

/**
 * Tweaks to make line charts more readable per note on 2023-03-15
 * NOTE: Only supports 6 elements instead of the 10 in original
 */
export const LINE_CHART_COLOR_SCHEME: Color = {
    name: "line-chart",
    selectable: true,
    group: ScaleType.Linear,
    domain: [
        COLOR_SCHEME.domain[0],
        COLOR_SCHEME.domain[1],
        COLOR_SCHEME.domain[4],
        COLOR_SCHEME.domain[8],
        COLOR_SCHEME.domain[3],
        COLOR_SCHEME.domain[5]
    ]
};

export const FORCING_REPORT_SCHEME: Color = {
    name: "forcing-report",
    selectable: true,
    group: ScaleType.Linear,
    domain: ["#af1725"]
};

export interface IStartEndDate {
    start: Date;
    end: Date;
}

export class DateValidator {
    static requiredDate(c: AbstractControl): { [key: string]: boolean } | null {
        const dateRegEx = new RegExp(/\d{1,2}\/\d{1,2}\/\d{4}/);
        if (c.value instanceof Date) {
            const str = `${c.value.getMonth()}/${c.value.getDate()}/${c.value.getFullYear()}`;
            return dateRegEx.test(str) ? null : { date: true };
        } else if (typeof c.value === "string") {
            const cast = new Date(c.value);
            const str = `${cast.getMonth()}/${cast.getDate()}/${cast.getFullYear()}`;
            return dateRegEx.test(str) ? null : { date: true };
        }

        return dateRegEx.test(c.value) ? null : { date: true };
    }

    // Date validator that does not imply a non-null value
    static date(c: AbstractControl): { [key: string]: boolean } | null {
        if (c.value !== null) {
            const dateRegEx = new RegExp(/\d{1,2}\/\d{1,2}\/\d{4}/);
            if (c.value instanceof Date) {
                const str = `${c.value.getMonth()}/${c.value.getDate()}/${c.value.getFullYear()}`;
                return dateRegEx.test(str) ? null : { date: true };
            } else if (typeof c.value === "string") {
                const cast = new Date(c.value);
                const str = `${cast.getMonth()}/${cast.getDate()}/${cast.getFullYear()}`;
                return dateRegEx.test(str) ? null : { date: true };
            }

            return dateRegEx.test(c.value) ? null : { date: true };
        } else {
            return null;
        }
    }
}

export type DateRangePreset =
    | "forcing"
    | "lender-review"
    | "transaction"
    | "tracking"
    | "default";

@Injectable()
export class AppService {
    private _btnClickObs = new Subject<StatusUpdateType>();

    private _dateRangePreset = signal<DateRangePreset>("default");
    readonly dateRangePresets = computed(this._dateRangePreset);

    readonly dateRangeDynamicStart = signal<Date | null>(null);

    getUpdateStatusObs() {
        return this._btnClickObs;
    }

    setUpdateStatusObs(val: StatusUpdateType) {
        this._btnClickObs.next(val);
    }

    setDateRangePreset(value: DateRangePreset) {
        this._dateRangePreset.set(value);
    }
}
